import React from 'react'
import { NavLink, useLocation } from 'react-router-dom'
import {
  Compass,
  ListTodo,
  GraduationCap,
  Calendar,
  MoreHorizontal
} from 'lucide-react'
import styles from './BottomNav.module.css'

export interface NavDestination {
  id: string
  label: string
  route: string
  icon: React.ComponentType<{ size?: number; className?: string }>
  isActive: (pathname: string) => boolean
}

export const PRIMARY_NAV_ITEMS: NavDestination[] = [
  {
    id: 'today',
    label: 'Today',
    route: '/dashboard',
    icon: Compass,
    isActive: (pathname: string) =>
      pathname === '/dashboard' || pathname === '/today' || pathname === '/'
  },
  {
    id: 'plan',
    label: 'Plan',
    route: '/plan',
    icon: ListTodo,
    isActive: (pathname: string) =>
      pathname.startsWith('/plan') ||
      pathname.startsWith('/planner') ||
      pathname.startsWith('/goals')
  },
  {
    id: 'learn',
    label: 'Learn',
    route: '/learning',
    icon: GraduationCap,
    isActive: (pathname: string) =>
      pathname.startsWith('/learning') ||
      pathname.startsWith('/french') ||
      pathname.startsWith('/language-goal') ||
      pathname.startsWith('/celpip')
  },
  {
    id: 'calendar',
    label: 'Calendar',
    route: '/calendar',
    icon: Calendar,
    isActive: (pathname: string) => pathname.startsWith('/calendar')
  },
  {
    id: 'more',
    label: 'More',
    route: '/more',
    icon: MoreHorizontal,
    isActive: (pathname: string) =>
      pathname.startsWith('/more') ||
      pathname.startsWith('/settings') ||
      pathname.startsWith('/profile') ||
      pathname.startsWith('/gita') ||
      pathname.startsWith('/playground')
  }
]

export function BottomNav() {
  const location = useLocation()

  return (
    <nav className={styles.bottomNav} aria-label="Mobile Navigation">
      <div className={styles.bar}>
        {PRIMARY_NAV_ITEMS.map((item) => {
          const Icon = item.icon
          const active = item.isActive(location.pathname)

          return (
            <NavLink
              key={item.id}
              to={item.route}
              className={`${styles.navItem} ${active ? styles.navItemActive : ''}`}
              aria-current={active ? 'page' : undefined}
            >
              <div className={styles.iconContainer}>
                <Icon size={20} className={styles.icon} />
                {active && <span className={styles.activePill} />}
              </div>
              <span className={styles.label}>{item.label}</span>
            </NavLink>
          )
        })}
      </div>
    </nav>
  )
}
